/* import __COLOCATED_TEMPLATE__ from './inl.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();